import { Title } from "@components/_Revamp/Typography/Title.stories";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import MainContainer from "@pages/EverGreen/Components/Container";
import InnerContainer from "@pages/EverGreen/Components/InnerContainer";
import { format } from "@pages/EverGreen/Helpers/helpers";
import { useAvivaSelector } from "@redux/hook";
import { updatePaymentMethod } from "@redux/slices/EVER_GREEN/step4Slice";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import { EverGreenStyle } from "@utils/Style/everGreen";
import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import InterbankForm from "./interbankForm";
import { InputGroup } from "@components/_Revamp/InputGroup";
import Button from "@pages/EverGreen/Components/Button";
import Modal from "@components/_Revamp/Modal";
import ConfirmButton from "./confirmBtn";
import SrsForm from "./srsform";
import TrenchesLimit from "@pages/EverGreen/Components/TrenchesLimit";
import { useHistory } from "react-router-dom";
import LearnPolicy from "./learn-policy";
import {
  trackOnFormStartOrSuccess,
  trackOnLoad,
} from "@pages/EverGreen/Helpers/analyticsHelper";

function Payment() {
  const dispatch = useDispatch();
  const amountSlected = useAvivaSelector(
    (state) => state.everGreenStep1.quotation.investingAmount
  );
  const userAgeBelow19 = useAvivaSelector(
    (state) => (state.everGreenStep2.myInfo.age || 0) < 18
  );
  const selectedPaymentMethod = useAvivaSelector(
    (state) => state.everGreenStep4.paymentMethod
  );
  // const isThirdPartPaying = useAvivaSelector(state=>state.everGreenStep4.interbankForm.isPayingSelf === "NO")
  const onPaymentSelectHandler = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      trackOnFormStartOrSuccess("DS_payment_option_form");
      const paymentMethod = e.currentTarget as HTMLButtonElement;
      dispatch(
        updatePaymentMethod(
          paymentMethod.getAttribute("data-paymenttype") as
            | "srs"
            | "interbank"
            | "fast"
            | "now"
        )
      );
    },
    []
  );
  const showModal = useAvivaSelector(
    (state) => state.everGreenStep4.trancheStatus
  );
  const adviser = useAvivaSelector(
    (state) => state.everGreenStep3.financialAdviser.autoAssignAgent || state.loading.campaignDetail?.product === "DIGITALSAVER"
  );
  const history = useHistory();
  //AA on load
  useEffect(() => {
    if (!adviser) return;

    trackOnLoad();
  }, []);

  if (!adviser) {
    history.replace(ROUTE_PATH.EVER_GREEN_FINANCIAL_ADVISER);
    return null;
  }
  return (
    //TODO Update the back button to review page
    <>
      <MainContainer backButtonPath={ROUTE_PATH.EVER_GREEN_REVIEW} step={4}>
        <Container className={marginBottom}>
          <Title variant="title" align="center">
            How would you like to pay?
          </Title>
          <Title variant="description" align="center">
            Select your preferred payment mode
          </Title>
        </Container>

        <InnerContainer>
          <AmountContiner>
            <span>{`Amount Payable `}</span>
            <span>{`S$${format(amountSlected)} (Single Premium)`}</span>
          </AmountContiner>
          <PaymentBtnContianer>
            <PaymentSelectionBtn
              onClick={onPaymentSelectHandler}
              data-paymenttype="interbank"
              data-selected={
                selectedPaymentMethod === "interbank" && "selected"
              }
            >
              <p>
                FAST & Interbank Transfer
              </p>
              <p style={{ fontSize: "12px", fontWeight: "500" }}>
              Transfer funds between participating banks and non-bank financial institutions in Singapore
              </p>
            </PaymentSelectionBtn>
            <PaymentSelectionBtn
              onClick={onPaymentSelectHandler}
              disabled={userAgeBelow19}
              data-paymenttype="srs"
              data-selected={selectedPaymentMethod === "srs" && "selected"}
            >
              <div>
                <p>Supplementary Retirement Scheme (SRS)</p>
                <p style={{ fontSize: "12px", fontWeight: "500" }}>
                You must be at least 18 years old to pay with SRS.
                </p>
              </div>
            </PaymentSelectionBtn>
          </PaymentBtnContianer>
          <PaymentBtnContianer>
            <PaymentSelectionBtn
              onClick={onPaymentSelectHandler}
              data-paymenttype="now"
              data-selected={selectedPaymentMethod === "now" && "selected"}
            >
              <div>
                <p>PayNow</p>
                <p style={{ fontSize: "12px", fontWeight: "500" }}>
                  Make an instant fund transfer using PayNow QR code.
                </p>
              </div>
            </PaymentSelectionBtn>
          </PaymentBtnContianer>
          <InstructionContainer
            className={`${
              selectedPaymentMethod === "interbank" && activeInterBank
            }`}
          >
            {/* <h4>How to make payment via Interbank Fund Transfer</h4>
            <p>
              Head over to your mobile app to make payment on the confirmation
              page. Do take note of the Bank account number and payee name in
              the confirmation confirmation page, as your policy number will
              need to be stated in the reference fields when making the
              transfer.
            </p> */}
            {/* <LearnPolicy /> */}
          </InstructionContainer>
          <InstructionContainer
            className={`${selectedPaymentMethod === "srs" && active}`}
          >
            <SrsForm show={selectedPaymentMethod} />
          </InstructionContainer>
        </InnerContainer>
        {/* <InterbankForm show={selectedPaymentMethod} /> */}
        {selectedPaymentMethod === "interbank" && false && (
          <InterbankTerms>
            <p>
              By clicking on "Submit application", you confirm that for the
              personal data of other individuals that you will be or are
              disclosing to Singlife, that you have prior to disclosing such
              personal data to Singlife, obtained the appropriate consent from
              the individual to:
            </p>
            <ul>
              <li>
                permit you to collect, use and/or disclose the
                individual&lsquo;s personal data to Singlife for the above
                purposes;
              </li>
              <li>
                permit Singlife to collect, use and/or disclose the
                individual&lsquo;s personal data for the above purposes; and
              </li>
              <li>
                permit Singlife to disclose and/or transfer the
                individual&lsquo;s personal data to
              </li>
              <li>
                <p>
                  (i) Singlife related group of companies, third party service
                  providers, reinsurers, suppliers and intermediaries (including
                  your financial adviser, where applicable);
                </p>
                <p>(ii) the Government of Singapore;</p>
                <p>(iii) statutory boards; and</p>
                <p>
                  (iv) organisations approved by the Government of Singapore,
                </p>
              </li>
            </ul>
            <p>
              whether located in Singapore or elsewhere, for the above purposes.
            </p>
          </InterbankTerms>
        )}
        <ConfirmButton />
      </MainContainer>
      {showModal === "Exceeded" && (
        <Modal className={modalPadding} show={showModal === "Exceeded"}>
          <TrenchesLimit
            closeModal={() => {
              window.location.replace(ROUTE_PATH.EVER_GREEN_LANDING_PAGE);
            }}
          />
        </Modal>
      )}
    </>
  );
}

export default Payment;

const InterbankTerms = styled.div`
  margin-top: 24px;
  max-width: 840px;
  width: 100%;
  font-weight: 500;
  font-size: 12px;
  line-height: 19.2px;
  letter-spacing: 0.18px;
  ul {
    margin-left: 14px;
    li:last-child {
      list-style: none;
      padding-left: 14px;
    }
  }
`;

const PaymentBtnContianer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  align-items: center;
  gap: 16px;
  margin: 24px 0;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    grid-template-columns: repeat(2, 1fr);

    justify-content: space-between;
  }
`;
const PaymentSelectionBtn = styled.button<{ disabled?: boolean }>`
  cursor: pointer;
  background-color: ${EverGreenStyle.colors.grey[700]};
  max-width: 384px;
  width: 100%;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  padding: 16px 36px;
  height: 100%;
  min-height: 82px;
  text-align: left;
  color: ${EverGreenStyle.colors.grey[1200]};
  border: none;
  line-height: 22.4px;
  transition-property: color background-color;
  transition-duration: 0.3s;
  transition-timing-function: linear;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &[data-selected="selected"] {
    background-color: ${EverGreenStyle.colors.primary};
    color: white;
  }
  &[data-paymenttype="srs"] {
    height: 120px;
    p:first-child {
      //max-width: 228px;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    /* &[data-paymenttype="srs"] {
       height: 98px;
    } */
  }
  &:hover {
    background-color: ${(props) =>
      props.disabled
        ? EverGreenStyle.colors.grey[700]
        : EverGreenStyle.colors.primary};
    color: ${(props) =>
      props.disabled ? EverGreenStyle.colors.grey[1200] : "white"};
  }
`;

const AmountContiner = styled.div`
  display: flex;
  flex-direction: column;
  span:nth-child(1) {
    font-size: 14px;
    font-weight: 600;
    line-height: 22.4px;
    color: ${EverGreenStyle.colors.grey[1400]};
  }
  span:nth-child(2) {
    color: ${EverGreenStyle.colors.primary};
    font-size: 18px;
    font-weight: 600;
    letter-spacing: ${18 * 0.015}px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: unset;
  }
`;

const Container = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

const marginBottom = css`
  margin-bottom: 24px;
  p:nth-child(2) {
    font-size: 14px;
    font-weight: 600;
    color: #8a8988;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    p:nth-child(1) {
      font-size: 28px;
      font-weight: 600;
    }
  }
`;

const InstructionContainer = styled.section`
  display: flex;
  flex-direction: column;
  line-height: 22.4px;
  color: ${EverGreenStyle.colors.grey[1400]};
  gap: 16px;
  overflow: hidden;
  height: 0px;
  h4 {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: ${16 * 0.015}px;
  }
  & > p {
    font-size: 14px;
    font-weight: 500;
    max-width: 792px;
    width: 100%;
  }
  & > ol {
    padding-left: 14px;
    li {
      font-size: 14px;
      font-weight: 500;
      line-height: 22.4px;
      max-width: 792px;
      width: 100%;
    }
  }
  .srs-form {
    display: grid;
    row-gap: 24px;
    div {
      p {
        font-size: 14px;
      }
    }
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      grid-template-rows: repeat(1, 1fr);
      row-gap: unset;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 24px;
    }
  }
`;
const active = css`
  overflow: hidden;
  height: 0px;
  animation: formanimation 0.3s linear 1 normal forwards;

  @keyframes formanimation {
    0% {
      overflow: hidden;
      height: 0px;
    }
    95% {
      overflow: unset;
      height: 410px;
    }
    100% {
      overflow: visible;
      height: fit-content;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    @keyframes formanimation {
      0% {
        overflow: hidden;
        height: 0px;
      }
      95% {
        overflow: unset;
        height: 190px;
      }
      100% {
        overflow: visible;
        height: fit-content;
      }
    }
  }
`;

const activeInterBank = css`
  overflow: hidden;
  height: 0px;
  animation: formanimation 0.3s linear 0s 1 normal forwards;

  @keyframes formanimation {
    0% {
      overflow: hidden;
      height: 0px;
    }
    95% {
      overflow: unset;
      height: 0px;
    }
    100% {
      overflow: visible;
      height: fit-content;
    }
  }
`;

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;
